import { Button } from "@/components/ui/button"
import { DialogOptionsPopUpProps, DialogPopUpProps } from "../Interface"
import { FormatFieldName } from "./Utils"
import { TypeComponent } from "./Fields"
import { OptionsField } from "./Fields"
import { Dialog, DialogContent, DialogTitle, DialogFooter, DialogClose } from "@/components/ui/dialog"

export function DialogPopUp({open, setOpen, type, value, setValue, onSave, field_name}: DialogPopUpProps) {
    const handleSave = () => {
        onSave()
        setOpen(false)
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogTitle>Select {FormatFieldName(field_name)}</DialogTitle>

                <TypeComponent type={type} value={value} setValue={setValue} />

                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="outline">Cancel</Button>
                    </DialogClose>

                    <DialogClose asChild>
                        <Button onClick={handleSave}>Save</Button>
                    </DialogClose>
                </DialogFooter>         
            </DialogContent>
        </Dialog>
    )
}

// This if for the Options Pop Up which needs a new parameter that includes the options
export function DialogOptionsPopUp({open, setOpen, value, setValue, onSave, field_name, options}: DialogOptionsPopUpProps){
    const handleSave = () => {
        onSave()
        setOpen(false)
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogTitle>Select {FormatFieldName(field_name)}</DialogTitle>

                <OptionsField defaultValue={value} setValue={setValue} options={options} />

                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="outline">Cancel</Button>
                    </DialogClose>

                    <DialogClose asChild>
                        <Button onClick={handleSave}>Save</Button>
                    </DialogClose>
                </DialogFooter>         
            </DialogContent>
        </Dialog>
    )
}